import React from "react";
import { message, Upload } from 'antd';
import { UploadOutlined} from "@ant-design/icons";
const { Dragger } = Upload;
const props = {
  name: 'file',
  multiple: true,
  action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',

  onChange(info) {
    const { status } = info.file;

    if (status !== 'uploading') {
      console.log(info.file, info.fileList);
    }

    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },

  onDrop(e) {
    console.log('Dropped files', e.dataTransfer.files);
  },
};


const draggerupload = (props) => {
  return (
    <Dragger {...props} className="drag-drop-upload">
      <p className="ant-upload-drag-icon">
      <UploadOutlined className="icon" />
      </p>
      <p className="ant-upload-text">Upload Driving Licence </p>
      <p className="ant-upload-props">{props.title}</p>
    </Dragger>
  );
};

export default draggerupload;
